import 'regenerator-runtime/runtime';
import { createStore, applyMiddleware } from 'redux';
import { createEpicMiddleware } from 'redux-observable';
import {
  loadTranslations,
  setLocale,
  syncTranslationWithStore
} from 'react-redux-i18n';
import thunk from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly';
import rootEpic from '../epics';
import rootReducer from '../reducers';
import translations from '../i18n';
import { readTokenAction } from '../reducers/actions';
import { reportErrorMiddleware } from '../utils/middleware'


const epicMiddleware = createEpicMiddleware(rootEpic);

export const store = createStore(
  rootReducer,
  composeWithDevTools(
    applyMiddleware(
      epicMiddleware,
      thunk,
      reportErrorMiddleware
    )
  )
);

store.dispatch(readTokenAction());

syncTranslationWithStore(store);
store.dispatch(loadTranslations(translations));
store.dispatch(setLocale('en'));

export default function configureStore() {
  return store;
}



// WEBPACK FOOTER //
// ./src/store/index.js